import axios from 'axios';
import { removeCache } from '../../services';
import { getDeviceId, removeDeviceId } from '../../utils';

interface SignInProps {
  email: string;
  password: string;
}

interface ForgotPasswordProps {
  email: string;
}

interface CreateNewPasswordProps {
  password: string;
  passwordConfirmation: string;
  token?: string;
}

interface UpdatePasswordProps {
  currentPassword: string;
  password: string;
  passwordConfirmation: string;
}

class AuthService {
  signin = (props: SignInProps) =>
    axios.post('/auth/login', {
      email: props.email,
      password: props.password,
      deviceId: getDeviceId(),
    });

  forgotPassword = (props: ForgotPasswordProps) =>
    axios.patch('/auth/get-password-reset-instruction', {
      email: props.email,
    });

  createNewPassword = (props: CreateNewPasswordProps) =>
    axios.patch(
      '/auth/create-new-password',
      {
        password: props.password,
        passwordConfirmation: props.passwordConfirmation,
      },
      {
        headers: {
          Authorization: `Bearer ${props.token}`,
        },
      },
    );

  updatePassword = (props: UpdatePasswordProps) =>
    axios.patch('/auth/update-password', {
      currentPassword: props.currentPassword,
      password: props.password,
      passwordConfirmation: props.passwordConfirmation,
    });

  logout = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('dashboard-drawer');
    removeDeviceId();
    removeCache('*');

    return Promise.resolve(true);
  };

  logoutOnError = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('dashboard-drawer');
    removeDeviceId();
    removeCache('*');

    window.location.href = '/signin';
  };
}

export const authService = new AuthService();
